import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Menu } from "@mui/material";
import { useState } from "react";

import { ConfirmationDialog } from "@/components/molecules/ConfirmationDialog";
import { IClosedDays } from "@/interfaces/closed-days.interface";
import { ConfigurationTabMessages } from "@/messages/customer/configuration-tab.messages";
import NotificationItem from "@/mui/Items/NotificationItem";

type Props = {
  isOpen: boolean;
  anchorEl: (EventTarget & HTMLButtonElement) | null;
  onClose: () => void;
  messages: ConfigurationTabMessages;
  selected: IClosedDays;
  onRemove: (item: IClosedDays) => void;
  onEdit: (item: IClosedDays) => void;
};

function ClosedDaysPopover({
  isOpen,
  anchorEl,
  onClose,
  messages,
  selected,
  onRemove,
  onEdit,
}: Props) {
  const [isDialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Menu
        open={isOpen}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <NotificationItem
          icon={<EditIcon />}
          title={messages.closedDaysEditPopover}
          onClick={() => {
            onEdit(selected);
            onClose();
          }}
        />
        <NotificationItem
          icon={<DeleteIcon />}
          title={messages.closedDaysDeletePopover}
          onClick={() => setDialogOpen(true)}
        />
      </Menu>

      <ConfirmationDialog
        isOpen={isDialogOpen}
        onClose={() => setDialogOpen(false)}
        onConfirm={() => {
          onRemove(selected);
          setDialogOpen(false);
          onClose();
        }}
        titleText={messages.closedDaysDeleteDialogTitle}
        descriptionText={messages.closedDaysDeleteDialogContent}
        cancelText={messages.closedDaysCancelButton}
        confirmText={messages.closedDaysDeletePopover}
        isLoading={false}
      />
    </>
  );
}

export default ClosedDaysPopover;
